// The database locks, compares and updates the row under the caller's RLS.
// Keep both long text arguments in the POST body, never in a URL filter.
export async function saveRefinedTranscript(client, patientId, consultationId, original, refined, signal) {
  const checkAbort = () => { if (signal?.aborted) throw new DOMException('Cancelled', 'AbortError'); };
  checkAbort();
  let request = client.rpc('save_refined_transcript', {
    p_patient_id: patientId,
    p_consultation_id: consultationId,
    p_original: original,
    p_refined: refined,
  });
  if (signal) request = request.abortSignal(signal);
  const { data, error, status } = await request;
  checkAbort();
  if (error) throw Object.assign(error, { status });
  if (data === 'saved' || data === 'already_saved') return;
  if (data === 'conflict') throw new Error('The transcript has changed. Your newer saved text was kept.');
  if (data === 'not_found') throw new Error('The consultation could not be loaded.');
  throw new Error('The transcript save could not be confirmed. Please retry.');
}
